import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Auth } from '../services/auth';

export const roleGuard: CanActivateFn = async () => {
  const auth = inject(Auth);
  const router = inject(Router);

  await auth.initialized;

  const user = auth.session()?.user;

  if (auth.isAuthenticated && user && user.user_metadata['role'] === 'ADMIN') {
    return true;
  }

  router.navigate(['/']);
  return false;
};
